import { StatisticType } from '../../../../apis/graphql/types';
import { ChartsData } from '../../../../components/BlueTheme/ChartComponent/DiagramComponent';
import { ColorSchemeType } from './constant';

export const convertDataForChart = (
  data: StatisticType[] | undefined | null,
  colorScheme: ColorSchemeType
): ChartsData[] | null => {
  if (!data) {
    return null;
  }

  return data.map(({ type, value }, index) => {
    const color: string = colorScheme.colors[index % colorScheme.colors.length];

    return {
      name: type,
      value: Number(value),
      color,
    };
  });
};
